'use strict';

var app  = require('mag-app'),
    keys = require('stb-keys'),

    Widget = require('spa-component-widget'),
    ModalMessage  = require('mag-component-modal'),
    LayoutList    = require('mag-component-layout-list'),
    exitModal = new ModalMessage({
        title: gettext('Exit'),
        visible: true
    }),
    widget = new Widget({
        $node: window.widgetExitConfirm,
        visible: false,
        events: {
            show: function () {
                exitModal.focus();
            }
        }
    });


exitModal.add(new LayoutList({
    parent: exitModal,
    className: 'padded',
    size: 2,
    focusIndex: 0,
    data: [
        {
            items: [
                {
                    value: gettext('Yes')
                }
            ],
            click: function () {
                if ( PLATFORM === 'STB' ) {
                    if ( app.query.standalone ) {
                        window.top.stbWebWindow.close();
                    } else {
                        app.exit();
                    }
                } else {
                    app.exit();
                }
            }
        },
        {
            items: [
                {
                    value: gettext('No')
                }
            ],
            click: function () {
                // widget
                exitModal.parent.hide();
            }
        }
    ],
    events: {
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
            if ( event.code === keys.back ) {
                event.stop = true;
                // widget
                exitModal.parent.hide();
            }
        }
    }
}));
widget.add(exitModal);


module.exports = widget;
